import React from "react";

import { StyledFlag } from "./styles";

interface FlagProps {
  countryCode: string;
}

export const Flag: React.FC<FlagProps> = ({ countryCode }) => (
  <StyledFlag aria-hidden>
    <span
      className={`flag-icon flag-icon-${countryCode.toLocaleLowerCase()}`}
    />
  </StyledFlag>
);
